export var AlertVariants;
(function (AlertVariants) {
    AlertVariants["neutral"] = "neutral";
    AlertVariants["success"] = "success";
    AlertVariants["error"] = "error";
})(AlertVariants || (AlertVariants = {}));
//# sourceMappingURL=constants.js.map